export const CURRENCY = "₹";

export const PLANS = [
  {
    id: "starter", name: "Starter", tagline: "For individual photographers",
    price: 1999, period: "mo",
    features: ["Up to 10 events", "50 GB secure storage", "AI face & selfie search", "Client galleries + QR codes", "Album selection workflow", "Basic analytics"],
  },
  {
    id: "professional", name: "Professional", tagline: "For growing studios",
    price: 4999, period: "mo", popular: true,
    features: ["Up to 50 events", "500 GB secure storage", "Advanced AI face matching", "Custom watermark & branding", "Priority processing", "Full analytics suite", "Up to 5 team members"],
  },
  {
    id: "studio", name: "Studio", tagline: "For professional studios & teams",
    price: 12999, period: "mo",
    features: ["Unlimited events", "2 TB secure storage", "Unlimited AI face searches", "Multi-photographer teams", "White-label galleries", "Dedicated support", "Up to 25 team members"],
  },
];

export const inr = (n) => "₹" + Number(n).toLocaleString("en-IN");
